import { render } from "./VabeneAddCustomer.vue?vue&type=template&id=3ce70a94&ts=true"
import script from "./VabeneAddCustomer.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCustomer.vue?vue&type=script&lang=ts"

import "./VabeneAddCustomer.vue?vue&type=style&index=0&id=3ce70a94&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__